import React, { useEffect, useState } from 'react';
import PdsIcon from '../../images/pds-icon.svg';
import EmailSuccess from '../../images/email-success.png';
import { EmailVerification } from '../EmailVerificationPage/styles.js';
import PricingPlan from '../../components/PricingPlan';
import { useContext } from 'react';
import { AppStoreContext } from '../../context/appStoreContext';
import Button from '../../components/Button';
import URL from '../../utils/helper';
import {
  verifyEmail,
  getUserMail,
  createCheckout,
  fetchUserDetails,
} from '../../utils/services/authAPI';
import { useHistory } from 'react-router-dom';
import SessionAuthWrapper from '../../components/SessionAuthWrapper';
import { Icon, message } from 'antd';
import { withTranslation } from 'react-i18next';
import { EMAIL_VERIFICATION_SUCCESS } from './translationValues';
import { getIndexedDBData } from '../../utils/indexedDBUtil';

const NAMESPACES = ['EMAIL_VERIFICATION_SUCCESS'];
// const REDIRECTION_URL = 'http://localhost:7000'; // TODO : Enable this to test in localhost
const REDIRECTION_URL = `${URL.FRONTEND_URL}`;

function EmailVerificationSuccess(props) {
  const { t } = props;

  const getSearchParams = param => {
    const query = new URLSearchParams(window.location.search);
    return query.get(param);
  };

  const [selectedPricingPlan, setSelectedPricingPlan] = useState('');
  const [userName, setUserName] = useState('');
  const [sessionInfo, setSessionInfo] = useState({ isActive: false, isLoggedIn: false });
  const [showSessionAuthWrapper, setShowSessionAuthWrapper] = useState(false);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const {
    setUserDetails,
    loginVisible,
  } = useContext(AppStoreContext);

  //Setting state to hide EmailVerification page after proceeding to checkout
  const proceedToCheckout = async () => {
    setLoading(true);
    // Call SessionAuthWrapper to check for an existing session    

    setShowSessionAuthWrapper(true);

  };

  const createChekoutSession = async () => {
    const userDetails = await fetchUserDetails();

    if (userDetails?.statusCode === 1903) {
      const data = userDetails.data;
      setUserDetails(data);
      const masterDesign = await getIndexedDBData('masterDocument');
      const payload = {
        organizationId: data?.organizationId,
        priceId: selectedPricingPlan,
        returnUrl: `${REDIRECTION_URL}${masterDesign ? `/openDesign/${masterDesign?.documentDTO?.id}` : ''}`
      };
      const result = await createCheckout(payload);

      //Route to the URL in the checkout API response
      if (result?.url) {
        window.location.replace(result?.url);
      }
    } else {
      message.error(t(EMAIL_VERIFICATION_SUCCESS.SOMETHING_WENT_WRONG_ERROR_MESSAGE.key, EMAIL_VERIFICATION_SUCCESS.SOMETHING_WENT_WRONG_ERROR_MESSAGE.value));
    }

  };

  useEffect(() => {
    //TODO: 2. If session exist, route to stripe checkout oage
    console.log("Change in sessionInfo  !!!!");
    if (sessionInfo.isActive) {
      createChekoutSession()
    }
  }, [setSessionInfo, sessionInfo]);


  const getUserName = email => {
    let name = email.split('@')[0];
    name = name.charAt(0).toUpperCase() + name.slice(1);
    return name;
  };

  //Verifying user email(POST API call) on page mount
  const verifyUserEmail = async () => {
    setSelectedPricingPlan(getSearchParams('planId'));
    let data = {
      method: 'token',
      token: getSearchParams('token'),
    };
    setIsLoading(true);
    let response = await verifyEmail(data);
    console.log({ response });
    setIsLoading(false);

    if (response?.status === 'EMAIL_VERIFICATION_INVALID_TOKEN_ERROR') {
      // This can happen if the verification code is expired or invalid.
      // You should ask the user to retry
      setError(t(EMAIL_VERIFICATION_SUCCESS.ERROR_LINK_EXPIRED.key, EMAIL_VERIFICATION_SUCCESS.ERROR_LINK_EXPIRED.value));
    } else if (response?.status === 'OK') {
      setUserName(response?.email && getUserName(response?.email));
    } else {
      setError('Unable to verify email, Please try again after sometime');
      return;
    }
  };

  const unVerifyUserEmail = async () => {
    const userMeta = await getUserMail();
    if (userMeta?.email) {
      let name = userMeta && userMeta?.email.split('@')[0];
      name = name.charAt(0).toUpperCase() + name.slice(1);
      setUserName(getUserName(name));
      setSelectedPricingPlan(userMeta?.planId);
    }
  };

  //  unVerifyUserEmail will call if we don't have email and plan details in params
  //  verifyUserEmail will call if we have token
  useEffect(() => {
    getSearchParams('token') ? verifyUserEmail() : unVerifyUserEmail();
  }, []);

  useEffect(() => {
    return () => {
      setIsLoading(false);
    };
  }, []);

  return (
    !error ?
    <>
      {isLoading || sessionInfo.isLoggedIn ? <EmailVerification>
        <Icon type="loading" style={{ fontSize: 40 }} className='default-loading' />
      </EmailVerification> :
      <>
        <EmailVerification>
          <div className="container full-screen">
            <img className="pds-logo" src={PdsIcon} alt="Perfect DocStudio" />
            <h2 className="heading">PERFECT DOC STUDIO</h2>
            <img className="email-success-logo" src={EmailSuccess} alt="Email Success" />
            {true ? ( //TODO: state to check if PTC failed
              <p className="info">
                {t(EMAIL_VERIFICATION_SUCCESS.EMAIL_VERIFICATION_SUCCESS_MESSAGE.key, EMAIL_VERIFICATION_SUCCESS.EMAIL_VERIFICATION_SUCCESS_MESSAGE.value, { userName: userName })}
              </p>
            ) : (
              <p className="info">
                {t(EMAIL_VERIFICATION_SUCCESS.EMAIL_VERIFICATION_ERROR_MESSAGE.key, EMAIL_VERIFICATION_SUCCESS.EMAIL_VERIFICATION_ERROR_MESSAGE.value, { userName: userName })}
              </p>
            )}
            <PricingPlan
              selectedPricingPlan={selectedPricingPlan}
              setSelectedPricingPlan={setSelectedPricingPlan}
              key={selectedPricingPlan}
            />
            <Button
              label={t(EMAIL_VERIFICATION_SUCCESS.PROCEED_TO_CHECKOUT_BUTTON.key, EMAIL_VERIFICATION_SUCCESS.PROCEED_TO_CHECKOUT_BUTTON.value)}
              onClick={proceedToCheckout}
              loading={loading}
              disabled={loading}
              large
            />
          </div >
        </EmailVerification >
        {showSessionAuthWrapper &&
          <SessionAuthWrapper
           setSessionInfo={setSessionInfo}
           doRedirection={true}
           requireAuth={true}
           visible={!loginVisible}
            />}
    </>
      }
    </>
    :
    <EmailVerification>
      <div className="error-container">
        <img className="pds-logo" src={PdsIcon} alt="Perfect DocStudio" />
        <h2 className="heading">{t(EMAIL_VERIFICATION_SUCCESS.EMAIL_VERIFICATION_FAILED_TITLE.key, EMAIL_VERIFICATION_SUCCESS.EMAIL_VERIFICATION_FAILED_TITLE.value)}</h2>
        <h4 className="error-message">{error}</h4>
      </div>
    </EmailVerification>
  )
}

export default withTranslation(NAMESPACES)(React.memo(EmailVerificationSuccess));